/* V3 product page enhancements (Direction B page, A buy box).
   Runs after v2-pdp.js. Everything here is display-only: it never changes
   the form, the variant radios, the line-item properties or the price. */
(function () {
  'use strict';
  var subnav = document.querySelector('[data-v3-subnav]');

  /* 1. Title display: the product is named "... Bundle" for fulfilment; the
        shopper reads "CLEAR Kit Expanded". Product data is untouched. */
  var fullTitle = null;
  document.querySelectorAll('.product__title h1, .product__title h2').forEach(function (h) {
    if (/ Bundle$/.test(h.textContent.trim())) { fullTitle = h.textContent.trim(); h.textContent = fullTitle.replace(/ Bundle$/, ''); }
  });
  /* The sticky purchase bar repeats the title and is filled in later by
     v2-pdp.js, so this runs now, again shortly after, and on the first scrolls. */
  var stripBundle = function () {
    if (!fullTitle) return;
    document.querySelectorAll('[class*="sticky"] *').forEach(function (el) {
      if (el.children.length === 0 && el.textContent.trim() === fullTitle) el.textContent = fullTitle.replace(/ Bundle$/, '');
    });
  };
  stripBundle(); setTimeout(stripBundle, 1500); setTimeout(stripBundle, 4000);
  var stripLeft = 6;
  window.addEventListener('scroll', function () { if (stripLeft-- > 0) stripBundle(); }, { passive: true });

  /* 2. Price deltas on the option cards, computed from the card prices.
        V4: the product has two option groups, so work per fieldset, and
        re-apply after Dawn re-renders the picker on a variant change. */
  var num = function (el) { var m = (el.textContent || '').replace(/,/g, '').match(/\$\s?(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; };
  var fmt = function (d) { return '+$' + (Number.isInteger(d) ? d : d.toFixed(2)); };
  var addDelta = function (fieldset, text) {
    var cards = Array.prototype.slice.call(fieldset.querySelectorAll('label.v2-optcard'));
    if (cards.length !== 2) return;
    var one = num(cards[0]), two = num(cards[1]);
    if (!(one > 0 && two > one) || cards[1].querySelector('.v3-delta')) return;
    var sub = document.createElement('span');
    sub.className = 'v2-optcard__sub v3-delta';
    sub.textContent = fmt(two - one) + ' ' + text;
    var price = cards[1].querySelector('.v2-optcard__price');
    if (price) cards[1].insertBefore(sub, price); else cards[1].appendChild(sub);
  };
  var addSub = function (card, text) {
    if (!card || card.querySelector('.v3-delta')) return;
    var sub = document.createElement('span'); sub.className = 'v2-optcard__sub v3-delta'; sub.textContent = text;
    var price = card.querySelector('.v2-optcard__price');
    if (price) card.insertBefore(sub, price); else card.appendChild(sub);
  };
  var applyDeltas = function () {
    var sets = Array.prototype.slice.call(document.querySelectorAll('#MainContent fieldset.product-form__input'));
    if (sets.length === 1) {
      addDelta(sets[0], 'for the second adult. Each adult gets their own binders; they share one case.');
    } else {
      sets.forEach(function (fs) {
        var legend = (fs.querySelector('legend') || {}).textContent || '';
        var cards = Array.prototype.slice.call(fs.querySelectorAll('label.v2-optcard'));
        if (/who is this/i.test(legend)) {
          addDelta(fs, 'for the second adult');
        } else if (/which clear kit/i.test(legend)) {
          // V5: say what each kit IS, without section counts (copy rule, 2026-10-08)
          addSub(cards[0], 'The essential sections');
          addSub(cards[1], 'Essentials plus every other section');
        }
      });
    }
    var note = document.querySelector('.v2-household__note');
    if (note && document.querySelector('.v3-delta')) note.hidden = true;
  };
  applyDeltas();
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) { setTimeout(applyDeltas, 400); setTimeout(applyDeltas, 1200); }
  }, true);

  /* 3. Trust trio under the rating (from the sub-nav section's settings). */
  if (subnav && subnav.dataset.trust) {
    var rating = document.querySelector('.v2rating');
    var host = rating || document.querySelector('.biwpdp-tagline');
    if (host && !document.querySelector('.v3-trio')) {
      var ul = document.createElement('ul'); ul.className = 'v3-trio'; ul.setAttribute('role', 'list');
      subnav.dataset.trust.split('|').forEach(function (t) { t = t.trim(); if (!t) return; var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
      host.insertAdjacentElement('afterend', ul);
    }
  }

  /* 4. Sticky sub-nav: resolve each link to a section wrapper by its key suffix,
        drop links whose target is missing, sit under the sticky header, mark
        the active item on scroll. */
  if (subnav) {
    var links = Array.prototype.slice.call(subnav.querySelectorAll('a[data-target]'));
    var targets = [];
    links.forEach(function (a) {
      var key = a.dataset.target, el = null;
      if (key === 'buy') el = document.querySelector('.product__info-wrapper') || document.getElementById('MainContent');
      else if (key === 'compare' || /compare-clear-kits/.test(key)) {
        /* V5: keep the shopper on the page - Compare opens the sections chart (same as Help me choose) */
        a.href = '#'; a.addEventListener('click', function (e) { e.preventDefault(); var t = document.querySelector('[data-v3-info-trigger]'); if (t) t.click(); });
        return;
      }
      else if (/^https?:|^\//.test(key)) { a.href = key; return; }
      else {
        /* V4: a key may have kit-specific twins (__key_eonly / __key_xonly);
           resolve to whichever is visible, at click time as well as now. */
        var twins = function () {
          var c = Array.prototype.slice.call(document.querySelectorAll('[id$="__' + key + '"], [id$="__' + key + '_eonly"], [id$="__' + key + '_xonly"]'));
          var vis = c.filter(function (x) { return x.offsetParent !== null; });
          return vis[0] || c[0] || document.getElementById(key);
        };
        el = twins();
        if (el) a.addEventListener('click', function (ev) { var t = twins(); if (t) { ev.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
      }
      if (!el) { a.remove(); return; }
      if (!el.id) el.id = 'v3-' + key;
      a.href = '#' + el.id; targets.push({ a: a, el: el, key: key });
    });
    if (targets.length < 2) { subnav.hidden = true; return; }
    /* The sticky header on this store is the BIW spine's section wrapper (position sticky,
       76px, z-index 9000), not Dawn's header. Ordered fallbacks rather than one comma list:
       the spine STRIP (40px, relative) shares the .biwspine class and comes first in the DOM.
       Position is measured live, so the sub-nav sits at the header's current bottom edge. */
    var header = document.querySelector('[id$="__biw_spine"]') || document.querySelector('.section-header') || document.querySelector('.shopify-section-header-sticky');
    var top = function () { if (!header) return 0; var p = getComputedStyle(header).position; if (p !== 'sticky' && p !== 'fixed') return 0; return Math.max(0, Math.round(header.getBoundingClientRect().bottom)); };
    var stickyEl = subnav.closest('.shopify-section') || subnav; /* the section wrapper is the sticky element */
    stickyEl.style.top = top() + 'px';
    targets.forEach(function (t) { t.el.style.scrollMarginTop = (top() + subnav.getBoundingClientRect().height + 8) + 'px'; });
    var ticking = false;
    var mark = function () {
      ticking = false;
      var t = top() + 'px'; if (stickyEl.style.top !== t) stickyEl.style.top = t;
      var y = window.scrollY + top() + subnav.getBoundingClientRect().height + 40, cur = targets[0];
      targets.forEach(function (t) { if (t.el.getBoundingClientRect().top + window.scrollY <= y) cur = t; });
      targets.forEach(function (t) { t.a.classList.toggle('is-on', t === cur); t.a.setAttribute('aria-current', t === cur ? 'true' : 'false'); });
      subnav.classList.toggle('is-stuck', stickyEl.getBoundingClientRect().top <= top() + 1);
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(mark); } }, { passive: true });
    window.addEventListener('resize', function () { stickyEl.style.top = top() + 'px'; mark(); });
    mark();
  }
})();
